import React from "react";
import { Link } from "react-router-dom";

export const Footer = (props) => {
  const data = props.data || {};
  const company = data.Company || {};
  const contact = data.Contact || {};
  const footer = data.Footer || {};
  const year = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="footer-main">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-sm-6 footer-col">
              <div className="footer-brand">
                <span className="brand-mark">{company.name}</span>
                <small className="brand-sub">{company.tagline}</small>
              </div>
              <p>{footer.blurb}</p>
              <p className="footer-ports">
                <i className="fa fa-ship"></i> {footer.ports}
              </p>
            </div>

            <div className="col-md-2 col-sm-6 footer-col">
              <h4>Company</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/about#quarries">Our Quarries</Link></li>
                <li><Link to="/about#factory">Barka Factory</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            <div className="col-md-3 col-sm-6 footer-col">
              <h4>Products</h4>
              <ul>
                <li><Link to="/products#blocks">Marble Blocks</Link></li>
                <li><Link to="/products#slabs">Marble Slabs</Link></li>
                <li><Link to="/products#finished">Finished Products</Link></li>
                <li><Link to="/products#aggregates">Chips, Lumps &amp; Aggregates</Link></li>
                <li><Link to="/granite">Granite</Link></li>
                <li><Link to="/granite#varieties">Granite Varieties</Link></li>
                <li><Link to="/#materials">Marble Types</Link></li>
              </ul>
            </div>

            <div className="col-md-3 col-sm-6 footer-col">
              <h4>Get in Touch</h4>
              <ul className="footer-contact">
                <li><i className="fa fa-map-marker"></i> {contact.address}</li>
                <li><i className="fa fa-phone"></i> {contact.phone}</li>
                <li><i className="fa fa-envelope-o"></i> {contact.email}</li>
                <li><i className="fa fa-clock-o"></i> {contact.hours}</li>
              </ul>
              <div className="social">
                <ul>
                  <li><a href={contact.linkedin || "#"} aria-label="LinkedIn"><i className="fa fa-linkedin"></i></a></li>
                  <li><a href={contact.facebook || "#"} aria-label="Facebook"><i className="fa fa-facebook"></i></a></li>
                  <li><a href={contact.instagram || "#"} aria-label="Instagram"><i className="fa fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-7">
              <p>{`© ${year} ${company.legalName || company.name}. All rights reserved.`}</p>
            </div>
            <div className="col-md-5 text-right footer-reg">
              <p>{footer.registration}</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
